import {Component, OnDestroy} from '@angular/core';
import {TabItemModel} from '../../../../models/tab-item-model';
import {ShareService} from "../../../../services/share.service";
import {Subscription} from "rxjs";
import {ValidationService} from "../../../../services/validation.service";

@Component({
  selector: 'app-install-heating',
  templateUrl: './install-heating.component.html',
  styleUrls: ['./install-heating.component.scss'],

})
export class InstallHeatingComponent implements OnDestroy {
  public tabs: TabItemModel[] = [
    {id: 0, label: 'Heizungsangaben', route: 'information', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 1, label: 'Heizungscheck', route: 'check', isDisabled: false, isVisible: true, isInvalid: false}
  ];

  private subscriptions: Subscription[] = [];

  constructor(
    private shareService: ShareService,
    private validationService: ValidationService,
  ) {
    this.subscriptions.push(this.shareService.heatingInformation$.subscribe(model => this.tabs[0].isInvalid = !this.validationService.isHeatingInformationValid(model)));
    this.subscriptions.push(this.shareService.heatingCheck$.subscribe(model => this.tabs[1].isInvalid = !this.validationService.isHeatingCheckValid(model)));
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
